/* eslint-disable max-classes-per-file */
import Enum from '@/modules/core/app/models/abstracts/Enum';

export class FormulaElementType extends Enum {
  static OPERAND = 'operand';

  static VARIABLE = 'variable';

  static SYMBOL = 'symbol';

  static FUNCTION = 'function';

  static COMPARISON = 'comparison';

  static KEYWORD = 'keyword';

  static NUMBER = 'number';

  static STRING = 'string';

  static PLACEHOLDER = 'placeholder';

  static MISSING = 'missing';

  static LOGIC = 'logic';

  static BREAK = 'break';

  static TABULATION = 'tab';

  static BOOLEAN = 'boolean';
}

export class FormulaElementSubType extends Enum {
  static AGGREGATE = 'aggregate';

  static STRING = 'string';
}

export const FormulaKeyword = {
  IF: 'IF',
  ELSE: 'ELSE',
  ELSEIF: 'ELSEIF',
  THEN: 'THEN',
  END: 'END',
  CASE: 'CASE',
  WHEN: 'WHEN',
};

export class FormulaSymbol extends Enum {
  static LEFT = '(';

  static RIGHT = ')';

  static COMMA = ',';
}

export const FormulaElementColor = {
  COMPARISON: '#f2a449',
  KEYWORD: '#6f22ff',
  STRING: '#76bf76',
};

export const FunctionType = {
  UPPER: 'UPPER',
  LOWER: 'LOWER',
  SUBSTR: 'SUBSTR',
  TRIM: 'TRIM',
  CONCAT: 'CONCAT',
  UNIQUECOUNT: 'UNIQUECOUNT',
  REPLACE: 'REPLACE',
  REPLACE_REGEX: 'REPLACE_REGEX',
  SUM: 'SUM',
  AVERAGE: 'AVG',
  MIN: 'MIN',
  MAX: 'MAX',
  COUNT: 'COUNT',
  CONTAINS: 'CONTAINS',
  MATCHES: 'MATCHES',
  LOGIC: 'LOGIC',
  LOCATE: 'LOCATE',
  EMPTY: 'EMPTY',
  CURRENT_DATE: 'CURRENT_DATE',
  LENGTH: 'LENGTH',
  SPLIT: 'SPLIT',
  GROUP_CONCAT: 'GROUP_CONCAT',
  TO_DATE: 'TO_DATE',
  FIRST_DAY: 'FIRST_DAY',
  LAST_DAY: 'LAST_DAY',
  DAY: 'DAY',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
  HOUR: 'HOUR',
  MINUTE: 'MINUTE',
  START_DATE: 'START_DATE',
  END_DATE: 'END_DATE',
  STARTS_WITH: 'STARTS_WITH',
  ENDS_WITH: 'ENDS_WITH',
  SUM_IF: 'SUM_IF',
  TO_TEXT: 'TO_TEXT',
  FLOOR: 'FLOOR',
  CEIL: 'CEIL',
  ROUND: 'ROUND',
  START_OF_DAY: 'START_OF_DAY',
  END_OF_DAY: 'END_OF_DAY',
  REMAINING_DAYS: 'REMAINING_DAYS',
  EXTRACT_REGEX: 'EXTRACT_REGEX',
  PERIOD: 'PERIOD',
};

export class FormulaOperator extends Enum {
  static PLUS = '+';

  static MINUS = '-';

  static MULTIPLY = '*';

  static DIVIDE = '/';

  static MOD = '%';
}

export class BasicCalculatorOperator extends Enum {
  static DOT = '.';

  static CLEAR_LAST_ENTRY = 'CE';

  static CLEAR_ALL = 'C';
}

export class FormulaComparison extends Enum {
  static GREATER = '>';

  static GREATER_OR_EQUAL = '>=';

  static LESSER = '<';

  static LESSER_OR_EQUAL = '<=';

  static EQUAL = '=';

  static NOT_EQUAL = '!=';
}

export class FormulaLogic extends Enum {
  static AND = 'AND';

  static OR = 'OR';

  static NOT = 'NOT';
}

export const FormulaElementConstant = {
  AUTO_COMPLETE_ENTER_FORMULA: 'autocomplete-enter-formula',
};

export class CalculationBusUIEvents extends Enum {
  static INPUT_FOCUS = 'CalculationBusUIEvents:input_focus';

  static ON_TAG_HOVER_IN = 'CalculationBusUIEvents:on_tag_hover_in';

  static ON_TAG_HOVER_OUT = 'CalculationBusUIEvents:on_tag_hover_out';
}

export class CalculationEvents extends Enum {
  static FORMULA_UPDATED = 'formula_updated';
}

export class CalculationDataType extends Enum {
  static NUMBER = 'Number';

  static DECIMAL = 'Decimal';

  static PERCENT = 'Percent';

  static CURRENCY = 'Currency';

  static TEXT = 'Text';
}

export const CalculationRoute = {
  CALCULATIONS: 'calculations',
};

export const CalculationPathName = {
  CALCULATIONS: 'calculations',
  CALCULATIONFORM_NEW: 'calculationform:new',
  CALCULATIONFORM: 'calculationform',
};

export class SyntaxReference extends Enum {
  static TEXT_BUILDER = 'calculationtextbuildersyntaxreference';

  static INTERACTIVE_BUILDER = 'calculationsyntaxreference';

  static FORM_FIELD_BUILDER = 'calculationformfieldsyntaxreference';
}

export const FormulaPlaceholders = {
  COMPARISON: 'comparison',
  DATE: 'date',
  FIELD: 'field',
  FORMAT: 'format',
  INDEX: 'index',
  LENGTH: 'length',
  OFFSET: 'offset',
  OPERATOR: 'operator',
  SEPARATOR: 'separator',
  START: 'start',
  SUBTEXT: 'subtext',
  TEXT: 'text',
  VALUE: 'value',
};
